<template>
    <div class="cart-page__body col-9 col-md-12">
        <div class="step-block">

            <steps-panel></steps-panel>

            <div class="step-block__head">
                <div class="step-block__title">Добавьте адрес доставки</div>
                <div class="step-block__small">* Необходимые Поля</div>
            </div>
            <div class="step-block__row row">
                <div class="step-block__input-row col-10 col-sm-12 col-xs-12">
                  <address-select v-on:address-selected="fillAddressFields"></address-select>
                </div>

                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">Имя*</div>
                    <input type="text" class="inputbox" v-model="model.name">
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">Фамилия*</div>
                    <input type="text" class="inputbox" v-model="model.surName">
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">E-mail*</div>
                    <input type="text" class="inputbox" v-model="model.email">
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">Телефон*</div>
                    <input type="text" class="inputbox" v-model="model.phone">
                </div>
                <div class="step-block__input-row col-10 col-sm-12">
                    <div class="checkbox checkbox--sm">
                        <input type="checkbox" id="delivery-subscribe" v-model="model.agreeSubscribe">
                        <label for="delivery-subscribe">Я хочу подписаться на рассылку, чтобы получить приоритетный доступ к распродажам и в числе первых узнавать о главных трендах и новинках.</label>
                    </div>
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">Выбрать город*</div>
                    <select
                            id="locationCode"
                            class="nice-select--ajax nice-select--search nice-select--normal"
                            data-js-placeholder="Начните вводить город"
                            data-ajax="/api/locations/search/">

                    </select>
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">Индекс</div>
                    <input type="text" class="inputbox" v-model="model.zip">
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="step-block__label">Улица*</div>
                    <input type="text" class="inputbox" v-model="model.street">
                </div>
                <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
                    <div class="row">
                        <div class="col-4">
                            <div class="step-block__label">Дом*</div>
                            <input type="text" class="inputbox" v-model="model.house">
                        </div>
                        <div class="col-4">
                            <div class="step-block__label">Корпус</div>
                            <input type="text" class="inputbox" v-model="model.building">
                        </div>
                        <div class="col-4">
                            <div class="step-block__label">Квартира</div>
                            <input type="text" class="inputbox" v-model="model.apartments">
                        </div>
                    </div>
                </div>

                <div class="step-block__input-row col-10 col-sm-12 col-xs-12">
                  <div class="step-block__label">Комментарий к заказу</div>
                  <textarea class="inputbox" v-model="model.comment"></textarea>
                </div>

                <div class="step-block__input-row col-4 radiobox-inline">
                    <div v-for="delivery in availableDeliveries" :key="delivery.ID" class="checkbox checkbox--sm">
                        <input type="radio" name="delivery" v-model="model.deliveryId" :value="delivery.ID" :id="'delivery-' + delivery.ID">
                        <label :for="'delivery-' + delivery.ID">{{ delivery.NAME }}</label>
                    </div>
                </div>		
            </div>
	    <div v-show="availableDeliveries.length > 0" class="step-block__label" style="color: grey">стоимость доставки рассчитывается отдельно</div>
            
              
            <div class="step-block__buttons hidden visible-sm">
                <a @click.prevent="nextStep" href="#" class="btn btn--black btn--next btn--md">
                    <span>Далее</span>
                    <svg class="icon btn__icon">
                        <use xlink:href="/local/templates/reloft2020/asset/images/sprite.svg#arrow-right"></use>
                    </svg>
                </a>

                <div class="input-row__error" v-for="(error, fieldName) in errors" :key="fieldName">{{ error }}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import StepsPanel from "@/components/Checkout/StepsPanel";
    import AddressSelect from "@/components/Checkout/AddressSelect";
    import {mapActions, mapState} from 'vuex';

    /* global $ */

    export default {
        name: 'StepDelivery',
        components: {
            StepsPanel,
            AddressSelect,
        },
        computed: {
            ...mapState('StoreCheckout', ['orderSummary', 'model', 'errors']),
            availableDeliveries: function () {
                return this.model.locationCode && this.orderSummary.availableDeliveries ? this.orderSummary.availableDeliveries : [];
            }
        },
        watch: {
            'model.locationCode': function () {
                this.loadOrderSummary(this.model);
            },
            'model.deliveryId': function () {
                this.loadOrderSummary(this.model);
            }
        },
        methods: {
            ...mapActions('StoreCheckout', ['loadOrderSummary', 'nextStep']),
          fillAddressFields(address) {
            this.$set(this.model, 'name', address.NAME ?? '');
            this.$set(this.model, 'surName', address.SURNAME ?? '');
            this.$set(this.model, 'email', address.EMAIL ?? '');
            this.$set(this.model, 'phone', address.SURNAME ?? '');
            this.$set(this.model, 'zip', address.ZIP ?? '');
            this.$set(this.model, 'street', address.STREET ?? '');
            this.$set(this.model, 'house', address.HOUSE ?? '');
            this.$set(this.model, 'building', address.BUILDING ?? '');
            this.$set(this.model, 'apartments', address.APARTMENTS ?? '');

            if (address.LOCATION_CODE) {
              const $select = $('#locationCode');
              $select.val(address.LOCATION_CODE).niceSelect('update');
              $select.append(`<option value="${address.LOCATION_CODE}" selected>${address.LOCATION.DISPLAY}</option>`);

              $select.niceSelect('update');

              this.$set(this.model, 'locationCode', address.LOCATION_CODE);
            }
          }
        },
        mounted() {
            let select = document.getElementById('locationCode');
            select.onchange = () => {
                this.model.locationCode = select.value;
            }
        }
    }
</script>